import { Activity, ChartLine, History, Key, KeyRound, LayoutDashboard, LayoutGrid, Library, ScrollText, Send, Settings, Smartphone, type LucideIcon } from 'lucide-react';
import { matchPath } from 'react-router';

export type NavItem = { to: string; label: string; icon: LucideIcon };

export const GLOBAL_NAV: NavItem[] = [
  { to: '/', label: 'Applications', icon: LayoutGrid },
  { to: '/ops', label: 'Queues & DLQ', icon: Activity },
  // Not /sdk: the dev server proxies /sdk/* to the API.
  { to: '/resources', label: 'Resources', icon: Library },
];

/** Sections of one application; `to` is relative to /apps/:appId. */
export const APP_NAV: NavItem[] = [
  { to: '', label: 'Overview', icon: LayoutDashboard },
  { to: 'credentials', label: 'Credentials', icon: KeyRound },
  { to: 'api-keys', label: 'API keys', icon: Key },
  { to: 'test-send', label: 'Send Notification', icon: Send },
  { to: 'sends', label: 'Notifications', icon: History },
  { to: 'installations', label: 'Devices', icon: Smartphone },
  { to: 'analytics', label: 'Analytics', icon: ChartLine },
  { to: 'audit', label: 'Audit log', icon: ScrollText },
  { to: 'settings', label: 'Settings', icon: Settings },
];

/** Layout components sit above the app route, so they read the app id from the URL themselves. */
export function currentAppRoute(pathname: string): { appId: string; section: string } | null {
  const m = matchPath('/apps/:appId/*', pathname);
  if (!m?.params.appId || m.params.appId === 'new') return null;
  return { appId: m.params.appId, section: (m.params['*'] ?? '').split('/')[0] ?? '' };
}
